import React from 'react'
import { useDimensions } from 'src/ui/dimensions'

import { WhyWe as Desc } from './desk'
import { WhyWe as Mob } from './mob'

type Props = {
  images: TImages
}
export const WhyWe: React.FC<Props> = ({ images }) => {
  const { isMobile } = useDimensions()
  return isMobile ? <Mob images={images} /> : <Desc images={images} />
}
